import React, { useState, useEffect } from 'react';

import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import DialogContent from '@material-ui/core/DialogContent';

import Translate, { useI18n } from '@hydra/common/components/i18n';
import Image from '@hydra/common/components/Image';
import FailedPayment from '@hydra/assets/img/failed_Payment_direct.png';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  dialog: { maxWidth: '650px' },
  titleConfirmation: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3)
  },
  content: {
    padding: theme.spacing(0, 0, 4),
    textAlign: 'center',
    '&:first-child': {
      paddingTop: 0
    }
  },
  image: {
    marginBottom: theme.spacing(3),
    maxWidth: '100%'
  },
  subTitle: {
    marginBottom: theme.spacing(3),
    fontSize: theme.typography.fontSizeBase
  }
}));

export const UpdatePaymentDialog = ({ open, preventClose = false }) => {
  const { locale } = useI18n();
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (open) {
      setIsOpen(true);
    }
  }, [open]);

  return (
    <Dialog
      fullWidth
      maxWidth='sm'
      open={isOpen}
      onClose={!preventClose ? () => setIsOpen(false) : null}
      classes={{ paperWidthSm: classes.dialog }}
    >
      <DialogContent
        classes={{ root: classes.content }}
      >
        <Image src={FailedPayment} className={classes.image} />
        <Typography variant='h3' component='h3' gutterBottom className={classes.titleConfirmation}>
          <Translate content='update_payment_dialog_title' />
        </Typography>
        <Typography paragraph color='textSecondary' className={classes.subTitle}>
          <Translate content='update_payment_dialog_subtitle' />
        </Typography>
        <Button
          size='medium'
          color='primary'
          variant='contained'
          href={`/${locale}/user/updatebilling`}
        >
          <Translate content='update_payment_dialog_btn' />
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(UpdatePaymentDialog);
